import * as Environment from "../base/Environment.js";

import {RenderContext} from "../base/Display.js";
import {AnimatableSprite, SolidSprite} from "../base/Display2D.js";

import {Site} from "./Site.js";
import {SiteSection} from "./SiteSection.js";

//
// VideoOverlay extends SiteSection
//

export const VideoOverlay = function (context) {
	SiteSection.apply (this, arguments);
	
};

window.VideoOverlay = VideoOverlay;

VideoOverlay.prototype = Object.create (SiteSection.prototype);

VideoOverlay.prototype.takeElement = function (element) {
	SiteSection.prototype.takeElement.apply (this, arguments);
	
	var videoElement = element.querySelector (".fullscreen-video-player--preview-image");
	
	var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|IEMobile|Mobile Safari|Opera Mini/i.test(navigator.userAgent);
	
	if (false && isMobile) {
		/*
			Fallback: use vanilla clappr player
		*/
		
		var anchor = element.querySelector ("a");
		if (anchor)
			anchor.parentNode.removeChild (anchor);
		
		videoElement.style.paddingBottom = 9 / 16 * 100 + "%";
		videoElement.style.background = "#f8f8f8";
		videoElement.style.cursor = "initial";
		videoElement.style.position = "relative";
		
		var overlayVideoPlayer = this.attachSprite (OverlayVideoPlayer);
		overlayVideoPlayer.sourceElement = videoElement;
		
		var staticPreviewImage = videoElement.querySelector ("img");
		var playerConfiguration = overlayVideoPlayer.configurePlayerInsideElement (videoElement);
		
		playerConfiguration.poster = staticPreviewImage.src;
		
		if (staticPreviewImage)
			staticPreviewImage.parentNode.removeChild (staticPreviewImage);
		
		// trace ("create static player", JSON.stringify (playerConfiguration));
		
		var player = this.player = new Clappr.Player (playerConfiguration);
		
	} else {
		function openVideoOverlay () {
			if (!Environment.IS_IN_NEOS_EDITOR)
				Site.sharedInstance.openVideoLayerFromSourceElement (videoElement);
			
		}
		
		var openLink = element.querySelector (".btn-simple-link");
		if (openLink) {
			openLink.addEventListener ("click", function (event) {
				event.preventDefault ();
				
				openVideoOverlay ();
				
			});
			
		}
		
		videoElement.addEventListener ("click", function (event) {
			openVideoOverlay ();
			
		});
		
		if (Environment.FAST_PASS) {
			/*
			window.setTimeout (function () {
				openVideoOverlay ();
				
			}.bind (this), 250);
			*/
			
		}
		
	}
	
};

//
// OverlayVideoPlayer extends AnimatableSprite
//

export const OverlayVideoPlayer = function (context) {
	AnimatableSprite.apply (this, arguments);
	
	var element = this.element;
	element.classList.add ("overlay-video-player");
	
};

OverlayVideoPlayer.prototype = Object.create (AnimatableSprite.prototype);

OverlayVideoPlayer.playerId = 1000;

OverlayVideoPlayer.prototype.configurePlayerInsideElement = function (element) {
	var sourceElement = this.sourceElement;
	
	var props = {
		playerId: OverlayVideoPlayer.playerId++,
		source: sourceElement.parentNode.getAttribute ("data-video-source"),
		previewImageUri: sourceElement.parentNode.getAttribute ("data-video-preview-image-uri") || "",
		subtitlesUri: sourceElement.parentNode.getAttribute ("data-subtitles-uri")
		
	};
	
	element.innerHTML = 
		'<div id="clappr-' + props.playerId + '"></div>';
	
	var playerConfiguration = {
		source: props.source.charAt (0) == "/" ?
			props.source :
			"https://s3.video-stream-hosting.de/oge-external-vod/_definst_/smil:" + props.source + ".smil/playlist.m3u8",
		parentId: "#clappr-" + props.playerId,
		poster: "", // props.previewImageUri || "https://mr341.video-stream-hosting.de/oge/external/" + props.source + ".jpg",
		
		width: "100%",
		height: "100%"
		
	};
	
	if (props.subtitlesUri && window.ClapprSubtitle) {
		playerConfiguration.plugins = [ClapprSubtitle];
		playerConfiguration.subtitle = {
			src: props.subtitlesUri,
			auto: true, // automatically loads subtitle
			backgroundColor: "transparent",
			fontWeight: "normal",
			fontSize: "18px",
			color: "white",
			textShadow: "1px 1px #000"
			
		}
		
	}
	
	return playerConfiguration;
	
};

OverlayVideoPlayer.prototype.startVideoWithSourceElement = function (sourceElement) {
	this.sourceElement = sourceElement;
	
	var background = this.background;
	if (background)
		this.removeChild (background);
	
	background = this.background = this.attachSprite (SolidSprite);
	background.element.classList.add ("overlay-video-player__background");
	
	const closeButton = this.closeButton = document.createElement ("div");
	closeButton.classList.add ("overlay-video-player__close-button");
	background.element.appendChild (closeButton);
	closeButton.addEventListener ("click", this.close.bind (this));
	
	var video = this.video = background.attachSprite (SolidSprite);
	video.element.classList.add ("video-player-wrapper");
	
	var playerConfiguration = this.configurePlayerInsideElement (video.element);
	playerConfiguration.autoPlay = true;
	
	var viewSize = this.getStage ().size;
	video.setSize (viewSize);
	
	
	playerConfiguration.events = {
		onPlay: function () {
			// trace ("play!");
			// player.__isPlaying__ = true;
			
		}.bind (this),
		onEnded: function () {
			Navigation.sharedInstance.leaveMode ();
			// this.close ();
			
		}.bind (this)
		
	};
	
	var player = this.player = new Clappr.Player (playerConfiguration);
	
	var videoElement = video.element.querySelector ("video");
	if (videoElement) {
		videoElement.setAttribute ("playsinline", "playsinline");
		videoElement.load (); // save click;
		
		function nudgePlayer () {
			window.setTimeout (function () {
				/*
				var posterImage = video.element.querySelector (".player-poster");
				
				var clickEvent = document.createEvent ("MouseEvents");
				clickEvent.initEvent ("click", true, false);
				posterImage.dispatchEvent (clickEvent);
				*/
				
				if (!player.isPlaying ()) {
					player.play ();
					nudgePlayer ();
					
				}
				
			}, 500);
			
		}
		
		nudgePlayer ();
		
	}
	
	this.startVideo ();
	
};

OverlayVideoPlayer.prototype.startVideo = function () {
	this.startAnimation ("Zoom", {direction: 1, rate: .03});
	document.body.classList.add ("scroll-locked");
	
};

OverlayVideoPlayer.prototype.close = function () {
	this.video.setSize (this.getStage ().size);
	
	this.startAnimation ("Zoom", {direction: 0, rate: .04});
	document.body.classList.remove ("scroll-locked");
	
};

OverlayVideoPlayer.prototype.animateZoom = function () {
	var state = this.updatedState ("Zoom");
	var t = state.phase;
	if (state.direction) {
		t = 1 - t;
		t = 1 - t * t * t;
		
	} else {
		t = t * t * t;
		
	}
	
	t = .5 - Math.cos (t * Math.PI) / 2;
	
	this.drawZoomForT (t);
	
};

OverlayVideoPlayer.prototype.drawZoomForT = function (t) {
	var viewSize = RenderContext.getViewportSize ();
	var scrollOffset = RenderContext.getScrollOffset ();
	
	var margins = [0, 0];
	
	this.lastT = t;
	var t_ = 1 - t;
	
	var video = this.video;
	var background = this.background;
	
	if (!t) {
		this.setAlpha (0);
		
		var player = this.player;
		player.destroy ();
		
	} else if (t < 1) {
		var sourceElement = this.sourceElement;
		var sourceFrameBounds = sourceElement.getBoundingClientRect ();
		
		var selfBounds = (document.documentElement || document.body).getBoundingClientRect ();
		
		var rectLeft = t_ * sourceFrameBounds.left;
		var rectTop = t_ * sourceFrameBounds.top;
		var rectRight = rectLeft + t_ * (sourceFrameBounds.right - sourceFrameBounds.left) + t * viewSize [0];
		var rectBottom = t_ * (sourceFrameBounds.bottom) + t * viewSize [1];
		
		background.setPosition (
			Math.round (rectLeft), Math.round (rectTop)
			
		);
		
		background.setSize (
			Math.round (rectRight - background.position [0]),
			Math.round (rectBottom - background.position [1])
			
		);
		
		var videoScale = background.size [0] / viewSize [0];
		
		video.element.style.transform = "scale(" + videoScale + ")";
		
		this.setAlpha (t * 4);
		
	} else {
		background.setPosition (0, 0);
		background.setSize ("100%", "100vh");
		
		video.setSize ("100%", "100vh");
		
		// video.element.style.transform = "";
		
		this.setAlpha (1);
		
	}
	
};
